// SYSTEM_ROUTE: /direction/challenges
import { DirectionLensView } from './DirectionLensView.js';

export function DirectionChallengesScreen() {
  return (
    <DirectionLensView
      lens="challenges"
      title="Challenges & Opportunities"
      subtitle="Active challenges and opportunities, placed on the control spectrum so effort goes where it can actually matter — control, influence, or accept."
      placeholder="Name a challenge or opportunity…"
    />
  );
}
